/** Human-readable titles for admin header breadcrumb. */
const ROUTE_MAP = {
  "/dashboard": "Dashboard",
  "/earinigs": "Admin Earnings",
  "/admin/alladmins": "All Admins",
  "/admin/addadmin": "Add Admin",
  "/admin/sitesettings": "Website Settings",
  "/admin/spin": "Spin Wheel",
  "/admin/bonus-links": "Bonus Links",
  "/admin/profile": "Profile",
  "/admin/update": "Update Password",
  "/user/allusers": "All Users",
  "/user/online-players": "Online Players",
  "/user/home-online-players": "Home Online",
  "/user/recently-online-players": "Recently Online (12h)",
  "/user/today-new-users": "Today New Users",
  "/user/adduser": "Add User",
  "/user/UserKyc": "Pending KYC",
  "/user/kyc": "Completed KYC",
  "/user/reject": "Rejected KYC",
  "/challenge/allchallenges": "All Challenges",
  "/challenge/completed_challange": "Completed",
  "/challenge/conflict_challange": "Conflict",
  "/challenge/cancelled_challange": "Cancelled",
  "/challenge/running_challange": "Running",
  "/challenge/drop_challange": "Drop",
  "/challenge/new_challange": "New",
  "/transaction/penaltybonus": "Penalty & Bonus",
  "/transaction/transaction_history": "Deposit History",
  "/transaction/bonus_history": "Bonus History",
  "/transaction/withdraw": "Withdrawal History",
  "/transaction/allwithdrawl": "Withdrawal Requests",
  "/transaction/alldeposits": "Deposit Requests",
  "/transaction/missing-deposit-requests": "Find My Deposit",
  "/Reports/bonusReport": "Bonus Report",
  "/Reports/depositReport": "Deposit Report",
  "/Reports/penaltyReport": "Penalty Report",
  "/Reports/withdrawalReport": "Withdrawal Report",
};

export function getAdminPageTitle(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  if (ROUTE_MAP[path]) return ROUTE_MAP[path];
  if (path.startsWith("/user/view_user/")) return "User Profile";
  if (path.startsWith("/user/adduser/")) return "Edit User";
  if (path.startsWith("/challenge/view/")) return "Challenge Detail";
  const seg = path.split("/").filter(Boolean);
  if (seg.length >= 2) {
    const key = `/${seg[0]}/${seg[1]}`;
    if (ROUTE_MAP[key]) return ROUTE_MAP[key];
  }
  if (seg.length >= 1) {
    const label = seg[seg.length - 1].replace(/_/g, " ").replace(/-/g, " ");
    return label.charAt(0).toUpperCase() + label.slice(1);
  }
  return "Admin Panel";
}

export function getAdminBreadcrumb(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  const parts = path.split("/").filter(Boolean);
  if (parts.length === 0) return ["Dashboard"];
  const crumbs = ["Admin"];
  if (parts[0]) {
    crumbs.push(parts[0].charAt(0).toUpperCase() + parts[0].slice(1));
  }
  if (parts.length > 1) {
    crumbs.push(getAdminPageTitle(path));
  }
  return crumbs;
}
